import './App.css';
import { BrowserRouter, Routes,Route } from "react-router-dom";
import Header from './Componenetes/Header'
import Home from './Componenetes/Home';
import Premios from './Componenetes/Premios';
import Galeria from './Componenetes/Galeria';
import Anteriores from './Componenetes/Anteriores';
import Bases from './Componenetes/Bases';
import Metapixel from "./Componenetes/Metapixel";

function App() {
  return (
    <div className="App">
        <BrowserRouter basename="/CasateConMartha2023/">
        {/*<BrowserRouter basename='/'>*/}
        <Metapixel/>
        <Header />
        <Routes path='*'>
          <Route path='' element={<Home/>}/>
          <Route path='/Premios' element={<Premios/>}/>
          <Route path='/Galeria' element={<Galeria/>}/>
          <Route path='/Anteriores' element={<Anteriores/>}/>
          <Route path='/Bases' element={<Bases/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
